import React, { createContext, useContext, useState, useEffect } from 'react';
import { getStoredLocale, setStoredLocale, getTranslation } from '../translations';

const LanguageContext = createContext(null);

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}

export function LanguageProvider({ children }) {
  const [locale, setLocaleState] = useState(getStoredLocale);

  useEffect(() => {
    setStoredLocale(locale);
  }, [locale]);

  const setLocale = (newLocale) => {
    if (newLocale === 'de' || newLocale === 'en') setLocaleState(newLocale);
  };

  const t = (key, params = {}) => {
    let s = getTranslation(locale, key);
    Object.keys(params).forEach((k) => {
      s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), params[k]);
    });
    return s;
  };

  return (
    <LanguageContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
